"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M17.026 2H5.974C4.884 2 4 2.933 4 4.083v15.834C4 21.067 4.884 22 5.974 22h11.052c1.09 0 1.974-.933 1.974-2.083V4.083C19 2.933 18.116 2 17.026 2zM11.5 21.167c-.655 0-1.184-.559-1.184-1.25 0-.692.529-1.25 1.184-1.25.655 0 1.184.558 1.184 1.25 0 .691-.529 1.25-1.184 1.25zm5.921-3.334H5.58V4.5h11.84v13.333z" }), "ResolutionMediumPortrait");
//# sourceMappingURL=ResolutionMediumPortrait.js.map